import { PhoneIcon } from "@heroicons/react/outline";
import { ChipIcon, SupportIcon } from "@heroicons/react/solid";
import {
  AiOutlineCloudServer,
  AiOutlineDatabase,
  AiOutlineShoppingCart,
  AiOutlineUserSwitch,
} from "react-icons/ai";
import { BsCurrencyBitcoin, BsNewspaper } from "react-icons/bs";
import {
  MdOutlineBusiness,
  MdOutlineDeveloperMode,
  MdSecurity,
} from "react-icons/md";
import { RiMessage3Line, RiTeamLine } from "react-icons/ri";
import { VscServerProcess } from "react-icons/vsc";

/* --- Server --- */
export const SERVER_BASE = window.location.origin;
// export const SERVER_BASE =
//   "http://itworld.utis.pk:8960" || process.env.REACT_APP_SERVER_BASE_URL;
// export const SERVER_BASE =
//   "http://localhost:8860" || process.env.REACT_APP_SERVER_BASE_URL;
// export const SERVER_BASE =
//   "http://192.168.18.88:8840" || process.env.REACT_APP_SERVER_BASE_URL;
export const SERVER = SERVER_BASE + "/api/v1";

/* --- Requests --- */
export const REQ = {
  STATUS: SERVER_BASE,
  USER: {
    VERIFY: SERVER + "/auth/me",
    LOGIN: SERVER + "/login",
    REGISTER: SERVER + "/register",
    SUBSCRIBE: {
      PRODUCT: SERVER + "/user/refer/product",
    },
  },
  ALERT: {
    ADD: SERVER + "/createAlert",
    GET_ALERT: SERVER + "/getAlert",
    GET_ALL_ALERT: SERVER + "/getAllAlert",
    DELETE_ALERT: SERVER + "/deleteAlert"
  },
  METER: {
    ADD: SERVER + "/getMeter",
    ADD_METER: SERVER + "/createMeter",
    EDIT_METER: SERVER + "/getMeterForUpdate",
    UPDATE_SINGLE_METER: SERVER + "/updateMeter",
    VIEW_METER: SERVER + "/viewMeter",
    ORDER_BY_DESC: SERVER + "/dataMeterDesc",
    ORDER_BY_ASC: SERVER + "/dataMeterAsc",
    ONE_DAY_PRE: SERVER + "/getMeterOnePrevious",
    ONE_DAY_NEXT: SERVER + "/getMeterOneNext",
    DELETE_METER: SERVER + "/deleteMeter",
    GET_LATEST_DATE: SERVER + "/latestEnteredOn",
  },
  DIP: {
    ADD: SERVER + "/getDip",
    EDIT_DIP: SERVER + "/getDipForUpdate",
    GET_LITRES_MM: SERVER + "/getSingleDip",
    ADD_DIP: SERVER + "/createDip",
    UPDATE_SINGLE_DIP: SERVER + "/updateDip",
    VIEW_DIP: SERVER + "/viewDip",
    ORDER_BY_DESC: SERVER + "/dataDipDesc",
    ORDER_BY_ASC: SERVER + "/dataDipAsc",
    ONE_DAY_PRE: SERVER + "/getDipOnePrevious",
    ONE_DAY_NEXT: SERVER + "/getDipOneNext",
    DELETE_DIP: SERVER + "/deleteDip",
  },
  PURCHASE: {
    GET_VOUCHER: SERVER + "/addPurchase",
    SAVE_DATA: SERVER + "/createPurchase",
    GET_DATA: SERVER + "/getPurchase",
    ORDER_BY_DESC: SERVER + "/dataPurchaseDesc",
    ONE_DAY_PRE: SERVER + "/dataPurchaseOnePre",
    ONE_DAY_NEXT: SERVER + "/dataPurchaseOneNext",
    ORDER_BY_ASC: SERVER + "/dataPurchaseAsc",
    UPDATE_PURCHASE: SERVER + "/updatePurchase",
    DELETE_SINGLE_INVOICE: SERVER + "/deleteSingleInvoice",
    DELETE_INVOICE: SERVER + "/deletePurchase",
    GET_REPORT: SERVER + "/getPurchaseByDate",
  },
  BULK_PURCHASE: {
    GET_VOUCHER: SERVER + "/addBulkPurchase",
    SAVE_DATA: SERVER + "/createBulkPurchase",
    GET_DATA: SERVER + "/getBulkPurchase",
    UPDATE_PURCHASE: SERVER + "/updateBulkPurchase",
    DELETE_INVOICE: SERVER + "/deleteBulkPurchase",
  },
  LUBE: {
    GET_VOUCHER: SERVER + "/addSale",
    SAVE_DATA: SERVER + "/createSale",
    GET_DATA: SERVER + "/getSale",
    UPDATE_SALE: SERVER + "/updateSale",
    DELETE_SINGLE_SALE: SERVER + "/deleteSingleSale",
    DELETE_SALE_VOUCHER: SERVER + "/deleteSale",
    ORDER_BY_DESC: SERVER + "/dataSaleDesc",
    ORDER_BY_ASC: SERVER + "/dataSaleAsc",
    ONE_DAY_PRE: SERVER + "/getSaleOnePrevious",
    ONE_DAY_NEXT: SERVER + "/getSaleOneNext",
  },
  RECEIPTS: {
    GET_VOUCHER: SERVER + "/addReceipt",
    GET_TRANSACTION_ID: SERVER + "/getTransactionId",
    SAVE_DATA: SERVER + "/createReceipt",
    GET_DATA: SERVER + "/getReceipt",
    ORDER_BY_DESC: SERVER + "/dataReceiptDesc",
    ONE_DAY_PRE: SERVER + "/dataReceiptOnePre",
    ONE_DAY_NEXT: SERVER + "/dataReceiptOneNext",
    ORDER_BY_ASC: SERVER + "/dataReceiptAsc",
    UPDATE_RECEIPTS: SERVER + "/updateReceipt",
    DELETE_SINGLE_RECEIPTS: SERVER + "/deleteSingleReceipt",
    DELETE_RECEIPTS: SERVER + "/deleteReceipt",
  },
  PAYMENT: {
    GET_VOUCHER: SERVER + "/addPayment",
    GET_TRANSACTION_ID: SERVER + "/getPaymentTransactionId",
    SAVE_DATA: SERVER + "/createPayment",
    GET_DATA: SERVER + "/getPayment",
    ORDER_BY_DESC: SERVER + "/dataPaymentDesc",
    ONE_DAY_PRE: SERVER + "/dataPaymentOnePre",
    ONE_DAY_NEXT: SERVER + "/dataPaymentOneNext",
    ORDER_BY_ASC: SERVER + "/dataPaymentAsc",
    UPDATE_PAYMENT: SERVER + "/updatePayment",
    DELETE_SINGLE_PAYMENT: SERVER + "/deleteSinglePayment",
    DELETE_PAYMENT: SERVER + "/deletePayment",
  },
  PETTY: {
    GET_VOUCHER: SERVER + "/addPettyPayment",
    GET_TRANSACTION_ID: SERVER + "/getPettyTransactionId",
    SAVE_DATA: SERVER + "/createPettyPayment",
    GET_DATA: SERVER + "/getPettyPayment",
    ORDER_BY_DESC: SERVER + "/dataPettyPaymentDesc",
    ONE_DAY_PRE: SERVER + "/dataPettyPaymentOnePre",
    ONE_DAY_NEXT: SERVER + "/dataPettyPaymentOneNext",
    ORDER_BY_ASC: SERVER + "/dataPettyPaymentAsc",
    UPDATE_PAYMENT: SERVER + "/updatePettyPayment",
    DELETE_SINGLE_PAYMENT: SERVER + "/deleteSinglePettyPayment",
    DELETE_PAYMENT: SERVER + "/deletePettyPayment",
  },
  BANK: {
    GET_VOUCHER: SERVER + "/addReceipt",
    GET_TRANSACTION_ID: SERVER + "/getTransactionId",
    SAVE_DATA: SERVER + "/createTransaction",
    GET_DATA: SERVER + "/getTransaction",
    UPDATE_BANK: SERVER + "/updateTransaction",
    DELETE_SINGLE_RECEIPTS: SERVER + "/deleteSingleBankEntry",
    DELETE_RECEIPTS: SERVER + "/deleteReceipt",
    ORDER_BY_DESC: SERVER + "/dataBankDesc",
    ONE_DAY_PRE: SERVER + "/dataBankOnePre",
    ONE_DAY_NEXT: SERVER + "/dataBankOneNext",
    ORDER_BY_ASC: SERVER + "/dataBankAsc",
  },
  BULK_SALE: {
    GET_VOUCHER: SERVER + "/addBulkSale",
    SAVE_DATA: SERVER + "/createBulkSale",
    GET_DATA: SERVER + "/getBulkSale",
    UPDATE_BULK_SALE: SERVER + "/updateBulkSale",
    DELETE_SINGLE_BULK_SALE: SERVER + "/deleteSingleBulkSale",
    DELETE_BULK_SALE: SERVER + "/deleteBulkSale",
  },
  TANK_LORRY: {
    GET_VOUCHER: SERVER + "/addTankLorry",
    SAVE_DATA: SERVER + "/createTankLorry",
    GET_DATA: SERVER + "/getTankLorry",
    GET_LORRY_DATA: SERVER + "/getTankLorryReport",
    UPDATE_TANK_LORRY: SERVER + "/updateTankLorry",
    DELETE_SINGLE_TANK_LORRY: SERVER + "/deleteSingleTankLorry",
    DELETE_TANK_LORRY: SERVER + "/deleteTankLorry",
  },
  JV: {
    GET_VOUCHER: SERVER + "/addJv",
    SAVE_DATA: SERVER + "/createJournalTransaction",
    GET_DATA: SERVER + "/getJournalTransaction",
    UPDATE_JOURNAL: SERVER + "/updateJournalTransaction",
    DELETE_SINGLE_TRANSACTION: SERVER + "/deleteSingalTransaction",
    DELETE_VOUCHER: SERVER + "/deleteJournalTransaction",
    DELETE_ZERO_ENRTY: SERVER + "/deleteZeroEntry",
  },
  OPENING_BALENCE_STOCK: {
    GET_DATE: SERVER + "/getStartingDate",
    SAVE_DATA: SERVER + "/addOpeningBalence",
    GET_DATA: SERVER + "/getOpeningBalence",
    UPDATE_OPENING: SERVER + "/updateOpeningBalence",
    DELETE_SINGLE_BAL: SERVER + "/deleteSingleBalence",
    DELETE_WHOLE: SERVER + "/deleteOpeningBalence",
  },
  OPENING_BALENCE_GL: {
    GET_DATE: SERVER + "/getOpeningDate",
    SAVE_DATA: SERVER + "/addGlBalence",
    GET_DATA: SERVER + "/getGlBalence",
    UPDATE_JOURNAL: SERVER + "/updateGlBalence",
    DELETE_SINGLE_TRANSACTION: SERVER + "/deleteSingalTransaction",
    DELETE_ALL: SERVER + "/deleteGlBalence",
    DELETE_ZERO_ENRTY: SERVER + "/deleteGlZeroEntry",
  },
  ITEM: {
    ADD_ITEM: SERVER + "/createItem",
    GET_ITEM: SERVER + "/getItem",
    UPDATE_ITEM: SERVER + "/updateItem",
    DELETE_ITEM: SERVER + "/deleteItem",
    GET_ALL_ITEM: SERVER + "/getAllItem",
    GET_LATEST_ITEM_CODE: SERVER + "/getItemCode",
    GET_ITEM_RATE: SERVER + "/getItemRate",
    GET_ITEM_QUANTITY: SERVER + "/itemQuantity",
  },
  SEARCH: {
    ALL_ITEMS: SERVER + "/getAllItemForList",
    GET_ALL_PARTY: SERVER + "/getAllParty",
    GET_ONLY_CUSTOMER: SERVER + "/getOnlyCustomer",
    GET_SUPPLIER_PARTY: SERVER + "/getSupplierParty",
    GET_CARD_PARTY: SERVER + "/getCardParty",
    GET_GENERAL_LEDGER: SERVER + "/getAllGeneralLedger",
    GET_EXPENSE_GENERAL_LEDGER: SERVER + "/getExpenseGeneralLedger",
    GET_BANK: SERVER + "/getAllBank",
    GET_SINGLE_ITEM: SERVER + "/getSingleItem",
    GET_BULK_PERMISSION: SERVER + "/bulkPermission",
  },
  TANK: {
    GET_BY_ID: SERVER + "/findTankByItem",
    GET_ALL_TANK: SERVER + "/getAllTank",
    GET_ALL_TANK_FOR_EDIT: SERVER + "/getAllTankForEdit",
    GET_TANK_ITEM: SERVER + "/getTankItem",
    ADD_TANK: SERVER + "/createTank",
    UPDATE_TANK: SERVER + "/updateTank",
    DELETE_TANK: SERVER + "/deleteTank",
  },
  NOZEL: {
    ADD_NOZEL: SERVER + "/createNozel",
    GET_ALL_NOZEL: SERVER + "/getAllNozel",
    UPDATE_NOZEL: SERVER + "/updateNozel",
    DELETE_NOZEL: SERVER + "/deleteNozel",
  },
  CEO: {
    ALL_PUMPS: SERVER + "/getAllCEOPumps",
  },
  ALL_REPORTS: {
    GET_STOCK_BALENCE: SERVER + "/procedureStockBalance",
    GET_DAY_BOOK: SERVER + "/procedureDayBook",
    GET_DAILY_SHEET: SERVER + "/procedureDailySheet",
    GET_GENERAL_LEDGER: SERVER + "/procedureGLedger",
    GET_PARTY_LEDGER: SERVER + "/procedurePLedger",
    GET_STOCK_REG: SERVER + "/procedureStockReg",
    GET_BULK_SALE_PURCHASE_REG: SERVER + "/procedureBulkSalePurchase",
    GET_N_SALE_PURCHASE_REG: SERVER + "/procedureNSalePurchase",
    GET_PURCHASE_REG: SERVER + "/purchaseRegister",
    GET_VEHICLE_EXP: SERVER + "/getVehicleExp",
    GET_SALE_REG: SERVER + "/saleRegister",
    GET_TRIAL_BAL: SERVER + "/trialBalance",
    GET_PARTY_BILL: SERVER + "/procedurePartyB",
    GET_CUSTOMER_BILL_SUMMARY: SERVER + "/procedureCustomerSummary",
    GET_CUSTOMER_BILL_SUMMARY_ITEM_WISE:
      SERVER + "/procedureCustomerSummaryItemWise",
    GET_CREDIT_SHEET: SERVER + "/creditSaleSheetEWise",
    GET_CREDIT_SHEET_VEHICLE_WISE: SERVER + "/creditSaleSheetVWise",
    GET_PROFIT_LOSS: SERVER + "/profitLossReport",
    GET_RATE_GL: SERVER + "/rateGLReport",
    GET_BULK_SALE_REPORT: SERVER + "/getBulkSaleReport",
    GET_SALETAX_REPORT: SERVER + "/getSaleTaxReport",
    GET_PENDING_APPROVALS: SERVER + "/pendingApproval",
    UPDATE_PENDING_APPROVALS: SERVER + "/updatePending",
  },
  REFRENCES: {
    GET_STITE_NAME: SERVER + "/findRefrence",
    GET_SITE_NAME: SERVER + "/findSite",
  },
  CHART_OF_ACCOUNT: {
    GET_ALL_ACCOUNT: SERVER + "/getAllAccount",
    ADD_ACCOUNT: SERVER + "/createAccount",
    UPDATE_ACCOUNT: SERVER + "/updateAccount",
    DELETE_ACCOUNT: SERVER + "/deleteAccount",
  },
  PARTY: {
    GET_ALL_ACCOUNT: SERVER + "/getAllParties",
    GET_SINGLE_ACCOUNT: SERVER + "/findSingleParty",
    ADD_ACCOUNT: SERVER + "/createParty",
    UPDATE_ACCOUNT: SERVER + "/updateParty",
    DELETE_ACCOUNT: SERVER + "/deleteParty",
  },
    BOOKING: {
    GET_ALL_Booking: SERVER + "/getAllBookings",
    GET_SINGLE_ACCOUNT: SERVER + "/findSingleParty",
    ADD_BOOKING: SERVER + "/createBooking",
    UPDATE_ACCOUNT: SERVER + "/updateBooking",
    DELETE_ACCOUNT: SERVER + "/deleteBooking",
  },
  CREDIT: {
    GET_PARTY_CODE: SERVER + "/getPartyByIssuedCoupon",
    GET_VEHICAL_BY_PARTY: SERVER + "/getVehicalByParty",
    GET_VEHICAL_DETAIL: SERVER + "/getVehical",
    GET_LATEST_COUPON: SERVER + "/getCoupon",
    SAVE_DATA: SERVER + "/createCreditSale",
    GET_DATA_BY_ENTEREDON: SERVER + "/getCreditSale",
    GET_DATA_BY_COUPON: SERVER + "/getCreditSaleByCoupon",
    UPDATE_SALE: SERVER + "/updateCreditSale",
    DELETE_SINGLE_COUPON: SERVER + "/deleteCreditSaleByCoupon",
    DELETE_BY_DATE: SERVER + "/deleteCreditSale",
    ORDER_BY_DESC: SERVER + "/dataCreditSaleDesc",
    ORDER_BY_ASC: SERVER + "/dataCreditSaleAsc",
    ONE_DAY_PRE: SERVER + "/getCreditOnePrevious",
    ONE_DAY_NEXT: SERVER + "/getCreditOneNext",
  },
  CARD: {
    SAVE_DATA: SERVER + "/createCardSale",
    GET_DATA_BY_ENTEREDON: SERVER + "/getCardSale",
    UPDATE_SALE: SERVER + "/updateCardSale",
    DELETE_SINGLE_SALE: SERVER + "/deleteCardSaleById",
    DELETE_BY_DATE: SERVER + "/deleteCardSale",
    ORDER_BY_DESC: SERVER + "/dataCardDesc",
    ORDER_BY_ASC: SERVER + "/dataCardAsc",
    ONE_DAY_PRE: SERVER + "/getCardOnePrevious",
    ONE_DAY_NEXT: SERVER + "/getCardOneNext",
  },
  VEHICAL: {
    SAVE_DATA: SERVER + "/createVehical",
    GET_ALL_VEHICAL: SERVER + "/getAllVehical",
    UPDATE_VEHICAL: SERVER + "/updateVehical",
    DELETE_VEHICAL: SERVER + "/deleteVehical",
  },
  SPECIAL_RATE: {
    SAVE_DATA: SERVER + "/createSpecialRate",
    GET_RATE: SERVER + "/getSpecialRate",
    UPDATE_RATE: SERVER + "/updateSpecialRate",
  },
  COUPON: {
    SAVE_DATA: SERVER + "/issueBook",
    GET_ALL_COUPON: SERVER + "/getAllCoupon",
    UPDATE_COUPON_BOOK: SERVER + "/editIssuedCoupon",
    DELETE_COUPON_BOOK: SERVER + "/deleteIssuedCoupon",
  },
  RATE_GAIN_LOSS: {
    GET_DATE: SERVER + "/getStartingDate",
    SAVE_DATA: SERVER + "/createRateGL",
    GET_DATA: SERVER + "/getOpeningBalence",
    UPDATE_OPENING: SERVER + "/updateOpeningBalence",
    DELETE_SINGLE_BAL: SERVER + "/deleteSingleBalence",
    DELETE_WHOLE: SERVER + "/deleteOpeningBalence",
  },
  MULTER_UPLOAD: {
    PIC_UPLOAD: SERVER + "/uploadPhoto",
  }
};

export const REGEX = {
  EMAIL: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,6}$/,
};

/* --- Errors --- */
export const ERR = {
  REFRESH: "Something went wrong, refresh to try again",
};

/* --- Support Data --- */
export const SUPPORT_DATA = [
  {
    icon: SupportIcon,
    title: "Consulting",
    description:
      "We help you create a clear digital strategy that optimizes your journey to total success in your technology-driven business.",
  },
  {
    icon: PhoneIcon,
    title: "Implementation",
    description:
      "Our expertise spans all key technologies and business functions, enabling us to provide comprehensive business solutions.",
  },
  {
    icon: ChipIcon,
    title: "Managed Services",
    description:
      "Our globally managed service teams secure your digital investment with 24/7 monitoring, maintenance and end-to-end support.",
  },
  {
    icon: ChipIcon,
    title: "BA",
    description:
      "Our experienced team, trained by business analysts, quickly supports your employees with timely, high-quality results.",
  },
];

/* --- All in One Data --- */
export const ALL_IN_ONE_DATA = [
  {
    icon: BsCurrencyBitcoin,
    title: "Blockchain",
  },
  {
    icon: AiOutlineShoppingCart,
    title: "Digital Commerce",
  },
  {
    icon: MdOutlineBusiness,
    title: "Business Application",
  },
  {
    icon: AiOutlineDatabase,
    title: "Data Management & Analytics",
  },
  {
    icon: VscServerProcess,
    title: "Business Process Outsourcing",
  },
  {
    icon: AiOutlineCloudServer,
    title: "Cloud Services",
  },
  {
    icon: MdOutlineDeveloperMode,
    title: "Application Development",
  },
  // {
  //   icon: MdOutlineIntegrationInstructions,
  //   title: "Application Integration",
  // },
  {
    icon: RiTeamLine,
    title: "Cloud Team",
  },
  {
    icon: MdSecurity,
    title: "Security",
  },
  {
    icon: BsNewspaper,
    title: "IT Infrastructure",
  },
  {
    icon: RiMessage3Line,
    title: "Quality Assurance",
  },
  {
    icon: AiOutlineUserSwitch,
    title: "User Experience",
  },
  // {
  //   icon: BsCurrencyBitcoin,
  //   title: "Application Modernization",
  // },
];
